import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a4d6064"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mb-3 input"
}
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "mb-3 input input-group" }
const _hoisted_4 = ["type", "placeholder", "id", "name", "autocomplete", "aria-describedby"]
const _hoisted_5 = ["id"]
const _hoisted_6 = {
  key: 1,
  class: "mb-3 input"
}
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "d-flex" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: ""
}, "----", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "+234" }, "NGN", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "+1" }, "UK", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "+233" }, "USA", -1))
const _hoisted_13 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "px-1" }, null, -1))
const _hoisted_15 = ["type", "placeholder", "id", "name", "disabled", "autocomplete"]
const _hoisted_16 = {
  key: 2,
  class: "mb-3 input"
}
const _hoisted_17 = ["for"]
const _hoisted_18 = {
  key: 1,
  class: "m_w_input"
}
const _hoisted_19 = ["type", "placeholder", "id", "name", "autocomplete"]
const _hoisted_20 = { key: 2 }
const _hoisted_21 = ["type", "placeholder", "id", "name", "autocomplete"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.inputType.type === 'password')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.label)
            ? (_openBlock(), _createElementBlock("label", {
                key: 0,
                for: _ctx.inputType.id
              }, _toDisplayString(_ctx.inputType.name), 9, _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("input", {
              type: _ctx.showPassword ? 'text' : 'password',
              placeholder: _ctx.inputType.name,
              class: "form-control py-2",
              id: _ctx.inputType.id,
              name: _ctx.inputType.id,
              value: "",
              onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit(`update:${_ctx.inputType.id}`, _ctx.handleInput($event)))),
              autocomplete: _ctx.inputType.autoComplete,
              "aria-describedby": _ctx.inputType.name
            }, null, 40, _hoisted_4),
            _createElementVNode("span", {
              class: "input-group-text",
              id: _ctx.inputType.name,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass([[_ctx.showPassword ? 'bi-eye-fill' : 'bi-eye-slash'], "icon"])
              }, null, 2)
            ], 8, _hoisted_5)
          ])
        ]))
      : (_ctx.inputType.type === 'tel')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.label)
              ? (_openBlock(), _createElementBlock("label", {
                  key: 0,
                  for: _ctx.inputType.id
                }, _toDisplayString(_ctx.inputType.name), 9, _hoisted_7))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("select", {
                onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit(`update:${_ctx.inputType.id}-code`, _ctx.handleInput($event)))),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.countryCode) = $event)),
                class: "form-select w-15",
                "aria-label": "Default select example",
                title: "Select country code",
                required: ""
              }, _hoisted_13, 544), [
                [_vModelSelect, _ctx.countryCode]
              ]),
              _hoisted_14,
              _createElementVNode("input", {
                type: _ctx.inputType.type,
                placeholder: _ctx.inputType.name,
                class: "form-control py-2 w-85",
                id: _ctx.inputType.id,
                name: _ctx.inputType.id,
                value: "",
                disabled: _ctx.countryCode === '' ? '' : _ctx.disabled,
                onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit(`update:${_ctx.inputType.id}`, _ctx.handleInput($event)))),
                autocomplete: _ctx.inputType.autoComplete
              }, null, 40, _hoisted_15)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
            (_ctx.label)
              ? (_openBlock(), _createElementBlock("label", {
                  key: 0,
                  for: _ctx.inputType.id
                }, _toDisplayString(_ctx.inputType?.label || _ctx.inputType?.name), 9, _hoisted_17))
              : _createCommentVNode("", true),
            (_ctx.toolTip)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("input", {
                    type: _ctx.inputType.type ? _ctx.inputType.type : 'text',
                    placeholder: 
            _ctx.inputType.placeholder ? _ctx.inputType.placeholder : _ctx.inputType.name
          ,
                    class: "form-control py-2 w_input",
                    id: _ctx.inputType.id,
                    name: _ctx.inputType.id,
                    value: "",
                    autocomplete: _ctx.inputType.autoComplete,
                    onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit(`update:${_ctx.inputType.id}`, _ctx.handleInput($event))))
                  }, null, 40, _hoisted_19),
                  _withDirectives(_createElementVNode("i", {
                    class: _normalizeClass(`bi bi-${_ctx.toolTip.icon} input_icon`)
                  }, null, 2), [
                    [
                      _directive_tooltip,
                      _ctx.toolTip.message,
                      void 0,
                      { left: true }
                    ]
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("input", {
                    type: _ctx.inputType.type ? _ctx.inputType.type : 'text',
                    placeholder: 
            _ctx.inputType.placeholder ? _ctx.inputType.placeholder : _ctx.inputType.name
          ,
                    class: "form-control py-2",
                    id: _ctx.inputType.id,
                    name: _ctx.inputType.id,
                    value: "",
                    autocomplete: _ctx.inputType.autoComplete,
                    onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit(`update:${_ctx.inputType.id}`, _ctx.handleInput($event))))
                  }, null, 40, _hoisted_21)
                ]))
          ]))
  ]))
}